export const copiasParaEntrega = (prestamo) =>
  (prestamo.libro?.copias ?? [])
    .filter((copia) => copia.disponible || copia.idCopia === prestamo.idCopia)
    .sort((a, b) => a.codigoCopia.localeCompare(b.codigoCopia));

export const opcionesCopiasEntrega = (prestamo) =>
  Object.fromEntries(copiasParaEntrega(prestamo).map((copia) => [
    String(copia.idCopia),
    `${copia.codigoCopia}${copia.idCopia === prestamo.idCopia ? " (reservada)" : ""}`,
  ]));

export const etiquetaCopia = (prestamo) => prestamo.codigoCopia || "Sin registro de copia";

export const formatearFechaHora = (fecha) => fecha
  ? new Date(fecha).toLocaleString("es-NI")
  : "Sin registro";
